import React, { useState } from "react";
import { Grid, Container } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import MultiDocs from "../../components/MultiDocs";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { useAlert } from "../../components/Alert";
import api from "../../globals/axios";
import { useNavigate } from "react-router-dom";
import SubmittingPopup from "../../components/Custom/FormSubmitPopup";
export default function DocumentsScreen() {
  const { t } = useTranslation();
  const [extraDocs, setExtraDocs] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const onFileChange = (e, index) => {
    if (extraDocs && extraDocs[index] !== undefined) {
      const updatedDocs = [...extraDocs];
      updatedDocs[index] = { ...updatedDocs[index], file: e.target.files[0] };
      setExtraDocs(updatedDocs);
    }
  };
  const onDocumentNameChange = (e, index) => {
    const updatedDocs = [...extraDocs];
    updatedDocs[index] = { ...updatedDocs[index], name: e.target.value };
    setExtraDocs(updatedDocs);
  };
  const submit = () => {
    // Check if at least one document has both file and name
    const hasValidDocument = extraDocs.some((doc) => doc.file && doc.name);
    if (!hasValidDocument) {
      showAlert(
        "warning",
        "Please provide both file and name for each document"
      );
      return;
    }

    setSubmitting(true);
    const uploadPromises = [];
    extraDocs.forEach((doc) => {
      if (doc.file && doc.name) {
        const formData = new FormData();
        formData.append("name", doc.name);
        formData.append("document", doc.file);

        uploadPromises.push(
          api.post("/fpo/documents/add/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        );
      }
    });

    Promise.all(uploadPromises)
      .then((responses) => {
        responses.forEach((response, index) => {
          const doc = extraDocs[index];
          if (response && response.data) {
            showAlert("success", `Document ${doc.name} uploaded successfully`);
          }
        });
        setExtraDocs([]);
        setSubmitting(false);
        navigate("/fpo/documents-list");
      })
      .catch((error) => {
        console.error("Error adding document:", error);
        setSubmitting(false);
      });
  };

  const onAddMore = () => {
    setExtraDocs([...extraDocs, {}]);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomTitle>{t(" Add Documents")}</CustomTitle>
            <MultiDocs
              extraDocs={extraDocs}
              onFileChange={onFileChange}
              onDocumentNameChange={onDocumentNameChange}
              submit={submit}
              onAddMore={onAddMore}
              t={t}
            />
            {submitting && <SubmittingPopup />}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
